export default "__VITE_ASSET__DTwUex$H__"